import { render, staticRenderFns } from "./TremoloEdit.vue?vue&type=template&id=c5668406&scoped=true&"
import script from "./TremoloEdit.vue?vue&type=script&lang=js&"
export * from "./TremoloEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5668406",
  null
  
)

export default component.exports